import * as yup from 'yup';
import moment from 'moment';

export const getValidationSchemaPage1 = () =>
  yup.object().shape({
    name: yup.string().required('Campo requerido'),
    lastName: yup.string().required('Campo requerido'),
    email: yup.string().email('Email no válido').required('Campo requerido'),
    repeatEmail: yup
      .string()
      .email('Email no válido')
      .oneOf([yup.ref('email'), null], 'Los emails deben coincidir')
      .required('Campo requerido')
  });

export const getValidationSchemaPage2 = () =>
  yup.object().shape({
    birthDate: yup
      .string()
      .required('Campo requerido')
      .test('valid-format', 'Fecha de nacimiento no válida', (value) =>
        moment(value, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid()
      )
      .test('is-adult', 'Necesitas tener al menos 18 años', (value) => {
        const d = moment(value, ['DD/MM/YYYY', 'D/M/YYYY'], true);
        if (!d.isValid()) return false;
        return d.isSameOrBefore(moment().subtract(18, 'years').endOf('day'));
      }),
    gender: yup.string().required('Campo requerido'),
    documentType: yup.string().required('Campo requerido'),
    documentNumber: yup
      .string()
      .matches(/^[0-9]*$/, 'El campo debe ser numérico')
      .test('len', 'El campo debe tener a lo sumo 9 dígitos', (val) => 
        !val || val.toString().length <= 9
      )
      .notOneOf(['0'], 'El campo no puede ser 0')
      .required('Campo requerido'),
    phoneNumber: yup
      .string()
      .matches(/^[0-9+\-() ]*$/, 'El número de teléfono solo puede contener dígitos, +, -, ( ) y espacios')
      .test('len', 'El número de teléfono debe tener entre 8 y 20 caracteres', (val) => 
        !val || (val.toString().length >= 8 && val.toString().length <= 20)
      )
      .notRequired(),
  });


export const getValidationSchemaPage3 = (hasPlans = false) =>
  yup.object().shape({
    healthInsurance: yup.string().required('Campo requerido'),
    plan: hasPlans 
      ? yup.string().required('Campo requerido') 
      : yup.string().notRequired(),
    credentialNumber: yup
      .string()
      .matches(/^[a-zA-Z0-9]*$/, 'El campo solo puede contener letras y números')
      .test('len', 'El campo puede tener hasta 30 caracteres', val => 
        !val || val.toString().length <= 30
      )
      .required('Campo requerido')
  });

export const isPageValid = (values, errors, page, hasPlans = false) => {
  if (page === 1) {
    return (
      values.name &&
      values.lastName &&
      values.email &&
      values.repeatEmail &&
      !errors.name &&
      !errors.lastName &&
      !errors.email &&
      !errors.repeatEmail
    );
  }
  
  if (page === 2) {
    return (
      values.birthDate &&
      values.gender &&
      values.documentType &&
      values.documentNumber &&
      !errors.birthDate &&
      !errors.gender &&
      !errors.documentType &&
      !errors.documentNumber
    );
  }
  
  if (page === 3) {
    const planValid = hasPlans ? values.plan && !errors.plan : true;
    return (
      values.healthInsurance &&
      values.credentialNumber &&
      !errors.healthInsurance &&
      !errors.credentialNumber &&
      planValid
    );
  }
  
  return false;
};